import { MoreVert } from "@mui/icons-material";
import {
  Avatar,
  AvatarGroup,
  Box,
  Button,
  ButtonBase,
  Chip,
  IconButton,
  Paper,
  Skeleton,
  Stack,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useEffect } from "react";
import { useDropzone } from "react-dropzone";
import { FcAddImage } from "react-icons/fc";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useSelector } from "react-redux";
import { dispatch } from "store";
import { createProductImageThunk } from "store/reducers/product/productSlice";
import addURLPrefix from "utils/addURLPrefix";

const ProductItem = ({
  product,
  handleClick,
  handleContextMenu,
  openGstDialog,
}) => {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const theme = useTheme();
  const bgColor = theme.palette.mode === "light" ? "grey.100" : "grey.700";
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    maxFiles: 5,
    accept: {
      "image/png": [".png"],
      "image/jpeg": [".jpg", ".jpeg"],
    },
  });
  const { loading } = useSelector((state) => state.product.imageStatus);
  useEffect(() => {
    if (acceptedFiles.length > 0) {
      acceptedFiles.forEach((file) => {
        dispatch(createProductImageThunk({ image: file, product: product.id }));
      });
    }
  }, [acceptedFiles, dispatch, product.id]);
  return (
    // <ButtonBase>
    <Paper
      elevation={1}
      sx={{
        height: isSmallScreen ? 180 : 150,
        cursor: "pointer",
        borderRadius: 2,
        position: "relative",
      }}
      onContextMenu={(e) => handleContextMenu(e, product)}
    >
      {product.product_type !== "none" && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: 24,
            height: 24,
            backgroundColor: "white",
            border: "2px solid white",
            boxShadow: "0 0 0 2px white",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderBottomRightRadius: 4,
          }}
        >
          <Box
            sx={{
              width: 16,
              height: 16,
              borderRadius: "50%",
              backgroundColor: product.product_type === "veg" ? "green" : "red",
            }}
          />
        </Box>
      )}

      <Stack direction="row">
        {product.images.length === 0 ? (
          <>
            {loading.create ? (
              <Skeleton
                variant="rectangular"
                sx={{ height: 160 }}
                animation="wave"
              />
            ) : (
              <Box
                height={isSmallScreen ? 180 : 150}
                width={120}
                sx={{
                  display: "flex",
                  backgroundColor: bgColor,
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                }}
                {...getRootProps({ className: "dropzone" })}
              >
                <input {...getInputProps()} />
                <Typography color="gray">Add few images</Typography>
                <FcAddImage size={30} />
              </Box>
            )}
          </>
        ) : (
          <LazyLoadImage
            style={{
              objectFit: "cover",
              height: isSmallScreen ? 180 : 150,
              width: 120,
              overflow: "hidden",
              borderTopLeftRadius: 8,
              borderBottomLeftRadius: 8,
            }}
            alt=""
            src={addURLPrefix(product.images[0].image)}
          />
        )}

        <Stack direction="column" flexGrow={1} paddingLeft={1}>
          <Stack
            padding={1}
            justifyContent="space-between"
            direction="row"
            alignItems="start"
          >
            <Tooltip title={product.name}>
              <Typography
                sx={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "-webkit-box",
                  WebkitLineClamp: "2",
                  WebkitBoxOrient: "vertical",
                  flexGrow: 1,
                }}
              >
                {product.name}
              </Typography>
            </Tooltip>

            <IconButton onClick={(e) => handleClick(e, product)}>
              <MoreVert />
            </IconButton>
          </Stack>
          <Stack direction="row">
            {product.variants.slice(0, 4).map((variant, index) => (
              <Chip
                key={index}
                label={`₹${variant.price}`}
                sx={{ margin: 0.2 }}
              />
            ))}
          </Stack>
          <Stack
            direction={isSmallScreen ? "column" : "row"}
            sx={{ marginTop: 0.5 }}
            justifyContent="space-between"
            alignItems="center"
          >
            <Box>
              <Typography variant="caption" component="div" display="inline">
                Validation required :
              </Typography>
              <Typography
                variant="overline"
                component="div"
                marginLeft={2}
                paddingY={0}
                color={product.validation_required ? "green" : "blue"}
                display="inline"
              >
                {product.validation_required ? "Yes" : "No"}
              </Typography>
            </Box>
            <Button
              variant="text"
              size="small"
              sx={{ mr: 2 }}
              onClick={() => openGstDialog(product)}
            >
              {product.gst ? "View Gst" : "Add Gst"}
            </Button>
          </Stack>
          <Stack direction="row" alignItems="center" sx={{ marginTop: 0 }}>
            <Typography variant="caption" component="div">
              Applied offers :
            </Typography>
            {product.offers.length > 0 ? (
              <Stack direction="row" marginLeft={2}>
                {product.offers.map((offer) => (
                  <Tooltip title={offer.name} disableInteractive>
                    <Chip
                      label={`${offer.offer_percentage}%`}
                      variant="outlined"
                      size="small"
                      clickable
                    />
                  </Tooltip>
                ))}
              </Stack>
            ) : (
              <Box marginLeft={2}>--</Box>
            )}
          </Stack>
        </Stack>
      </Stack>
    </Paper>
    // </ButtonBase>
  );
};

export default ProductItem;
